import { render, staticRenderFns } from "./ReclamationDetailsPage.vue?vue&type=template&id=4cd5f846&"
import script from "./ReclamationDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ReclamationDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports